import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isOpen: false,
};

const reviewPopupSlice = createSlice({
    name: 'reviewPopup',
    initialState,
    reducers: {
        openReviewPopup: (state) => {
            state.isOpen = true;
        },
        closeReviewPopup: (state) => {
            state.isOpen = false;
        },
        setReviewPopupOpen: (state, action) => {
            state.isOpen = action.payload;
        },
    },
});

export const { openReviewPopup, closeReviewPopup, setReviewPopupOpen } = reviewPopupSlice.actions;
export default reviewPopupSlice.reducer;
